import { ianaTldSet } from "./ianaTlds";

/** Reserved / private suffixes not listed as IANA TLDs but common in dev and tests. */
const additionalRecognizedTlds = new Set([
    "local",
    "localhost",
    "internal",
    "test",
    "example",
    "invalid",
]);

/**
 * If the value looks like an email (single @, host contains a dot) and the last
 * domain label is not a registered IANA TLD, returns that label for display; otherwise null.
 */
export function getUnknownEmailTldLabel(value: string): string | null {
    const trimmed = value.trim().toLowerCase();
    if (!trimmed.includes("@")) {
        return null;
    }
    const parts = trimmed.split("@");
    if (parts.length !== 2 || !parts[0] || !parts[1]) {
        return null;
    }
    const host = parts[1];
    if (!host.includes(".")) {
        return null;
    }
    const labels = host.split(".").filter(Boolean);
    const tld = labels[labels.length - 1];
    if (!tld || tld.length < 2) {
        return null;
    }
    if (ianaTldSet.has(tld) || additionalRecognizedTlds.has(tld)) {
        return null;
    }
    return tld;
}
